import { message, Space } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
    ModalItem,
    ButtonItem,
    dineroDisabledMask,
} from "../../../../Components/Items";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { Table, Typography } from "antd5";
import dayjs from "dayjs";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

const { Text } = Typography;

class ModalVerRemisionesVariasFacturas extends Component {
    formRef = React.createRef();
    state = {
        loading: false,
        pdf: null,
        ventas: []
    };
    componentDidUpdate(prevProps) {
        if (this.props.visible !== prevProps.visible && this.props.visible)
            this.consultarTodo();
    }
    async consultarTodo() {
        this.setState({ loading: true });
        await axios
            .post(
                "ventas/verRemisionesVariasFactura",
                { ventaId: this.props.id, empresaId: this.props.empresaId },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                if (res.data.success === 2) {
                    this.setState({
                        ventas: res.data.ventas || [],
                    })
                } else {
                    message.error("Sucedio un error al consultar las remisiones");
                }
            });
        this.setState({ loading: false });
    }
    cerrarVerRemisionesVariasFacturas(direccionar, id) {
        this.props.cerrarVerRemisionesVariasFacturas(direccionar, id);
    }

    openRegistro = (id) => {
        this.cerrarVerRemisionesVariasFacturas(true, id);
    }

    render() {

        const columns = [
            { title: "Número", dataIndex: "numero", key: "numero" },
            {
                title: "Fecha",
                dataIndex: "fecha",
                key: "fecha",
                render: (v) => (v ? dayjs(v).format("DD/MM/YYYY HH:mm") : "—"),
            },
            { title: "Insumos", dataIndex: "insumosLength", key: "insumosLength" },
            {
                title: "Total",
                dataIndex: "totalPagar",
                key: "totalPagar",
                align: "right",
                render: (v) => dineroDisabledMask(v || 0),
            },
            {
                title: "Acciones",
                key: "actions",
                fixed: "right",
                render: (_, row) => (
                    <Space>
                        <ButtonItem
                            type="primary"
                            onClick={() => this.openRegistro(row._id)} // 👈 push con props
                        >
                            Ver
                        </ButtonItem>
                    </Space>
                ),
            },
        ];

        return (
            <ModalItem
                title="Remisiones"
                visible={this.props.visible}
                spinning={this.state.loading}
                onCancel={() => this.cerrarVerRemisionesVariasFacturas()}
                paddingTop
                zIndex={this.props.zIndex}
            >
                {this.state?.ventas?.length ? (
                    <Table
                        rowKey={(r) => r._id}
                        dataSource={this.state.ventas}
                        columns={columns}
                        pagination={{ pageSize: 8 }}
                    />
                ) : (
                    <Text type="secondary">No hay registros para mostrar.</Text>
                )}
            </ModalItem>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        headersToken: state.user.headersToken,
        empresaId: state.empresa.id,
    };
};

export default connect(mapStateToProps)(ModalVerRemisionesVariasFacturas);
